export default __webpack_public_path__ + "static/media/ThePiano_01.3f39dbea.png";